export default __webpack_public_path__ + "static/media/Ballroll_00246.0025e7c0.png";